import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Vant, { Toast } from "vant";
import "vant/lib/index.css";
createApp(App)
  .use(router, Vant, Toast)
  .mount("#app");
